import React, { Fragment } from 'react';

import { tp } from 'app/utils/typograf';


export function DishCategoryTextLine(props) {
    const { children } = props;

    if (Array.isArray(children)) {
        return (
            <>
                {children.map((line) => (
                    <Fragment key={line}>
                        {tp.execute(line)}
                        <br />
                    </Fragment>
                ))}
            </>
        );
    }

    return tp.execute(children);
}
